export default {
  tenderWebApiUrl: process.env.VUE_APP_TENDER_WEBAPI_URL as string,
  tenderMVCSiteUrl: process.env.VUE_APP_TENDER_MVC_SITE_URL as string,
}